import React from 'react';

interface BadgeProps {
  className?: string;
  width?: number;
  height?: number;
}

const BadgeIcon = function Badge({
  className,
  width,
  height,
}: BadgeProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 6 6"
    >
      <circle cx="3" cy="3" r="3" fill="#F76A6A" />
    </svg>
  );
};

BadgeIcon.defaultProps = {
  className: '',
  width: 6,
  height: 6,
};

export default BadgeIcon;
